var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowEduYearlyNotification)?_c('BaseNotification',[_c('p',{staticClass:"mr-4"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$i18nPresenter.t('annualBillingNotification', {
        date: _vm.couponExpiryDate
      }))}})]),_c('aha-button',{staticClass:"md:ml-auto flex-grow-0 flex-shrink-0 h-6 my-2 sm:-mt-0.5 sm:mb-0",attrs:{"variant":"warning"},on:{"click":function($event){return _vm.upgrade()}}},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Learn more…'))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }